<template>
    <!-- Modal -->
    <div class="modal fade" id="transferModal" tabindex="-1" role="dialog" aria-labelledby="transferModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="col-sm-4 text-left">
                        <h5 class="modal-title font-weight-bold" id="actionRemarksTitle">{{booked.crew}}</h5>
                    </div>

                    <div class="col-sm-4 text-left border-left">
                        <span class="font-weight-bold">Booked check-in :</span> {{booked.booked_check_in |  moment('D MMM YYYY')}}
                    </div>

                    <div class="col-sm-4 text-left border-left">
                        <span class="font-weight-bold">Booked check-out :</span> {{booked.booked_check_out |  moment('D MMM YYYY')}}
                    </div>

                    <!-- <button type="button" class="close btn-sm" data-dismiss="modal" aria-label="Close" v-on:click="setThisNull">
                        <span aria-hidden="true">&times;</span>
                    </button>-->
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-3 text-left">
                            <div class="form-group">
                                <label for="bookedFrom" class="font-weight-bold"><sup class="text-danger">*</sup>Book Check In:</label>
                                <input type="date"
                                       class="form-control form-control-sm"
                                       id="bookedFrom"
                                       aria-describedby="emailHelp"
                                       v-on:input="setBookedIn"
                                       v-model="bookedIn"
                                       placeholder="Date In">
                            </div>
                        </div>

                        <div class="col-md-3 text-left">
                            <div class="form-group">
                                <label for="bookedTo" class="font-weight-bold"><sup class="text-danger">*</sup>Book Check Out:</label>
                                <input type="date"
                                       class="form-control form-control-sm"
                                       id="bookedTo"
                                       aria-describedby="emailHelp"
                                       v-on:input="setBookedOut"
                                       v-model="booked_out"
                                       placeholder="Date Out">
                            </div>
                        </div>

                        <div class="col-md-6 text-left">
                            <div class="form-group">
                                <label for="bookedRemarks" class="font-weight-bold"><sup class="text-danger">*</sup>Add Remarks :</label>
                                <textarea class="form-control form-control-sm"
                                          id="bookedRemarks"
                                          v-model="newRemarks.remarks"
                                          style="resize: none;" rows="3"
                                          @keydown="limiteTextRemarks('bookedRemarks','countdown2',200)">
                                </textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li class="nav-item" v-for="hotel in booked.hotels" :key="hotel.id">
                                    <a class="nav-link"
                                       :id="'pills-home-tab'+hotel.id"
                                       data-toggle="pill" :href="'#pills-home'+hotel.id"
                                       role="tab"
                                       aria-controls="pills-home"
                                       aria-selected="true"
                                       v-bind:class="isActive(hotel.id)"
                                       v-on:click.prevent="showTab(hotel.id)">
                                        {{hotel.name.toUpperCase()}}
                                    </a>
                                </li>
                            </ul>


                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade"
                                     v-show="tab == hotel.id"
                                     v-for="hotel in booked.hotels"
                                     :key="hotel.id"
                                     :id="'pills-home'+hotel.id"
                                     role="tabpanel"
                                     v-bind:class="isActive(hotel.id,true)"
                                     :aria-labelledby="'pills-home-tab'+hotel.id">
                                    <div class="row">
                                        <div class="col-md-6 text-left">
                                            <div class="form-group">
                                                <label for="exampleFormControlSelect1" class="font-weight-bold">Select Floor :</label>
                                                <select class="form-control form-control-sm w-15 font-weight-bold" id="exampleFormControlSelect1" v-model="floor_id" v-on:change="getRooms">
                                                    <option  :value="null" :selected="floor_id == null">---</option>
                                                    <option v-for="floor in floors"
                                                            :value="floor.id"
                                                            :key="floor.id"
                                                            :selected="floor.id == floor_id"
                                                            class="font-weight-bold">{{floor.code}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-5 text-left">
                                            <h5 class="font-weight-bold">Rooms Available</h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                    <tr class="text-left">
                                                        <th scope="col" width="70">
                                                            <button class="btn btn-sm ml-1"
                                                                    v-bind:class="{ 'tnkc-success': isInAvailable,'tnkc-secondary' : !isInAvailable}"
                                                                    v-on:click.prevent="setSelectAvailable">
                                                                {{isInAvailable ? 'Select' : 'Undo'}}
                                                            </button>
                                                        </th>
                                                        <th scope="col" width="140">Rooms</th>
                                                        <th scope="col" width="130">Beds</th>
                                                    </tr>
                                                    </thead>

                                                    <tbody style="height: 180px;">
                                                        <tr v-for="(roomAvailable,index) in roomsAvailable" :key="roomAvailable.bed_id" v-bind:class="roomsAvailableBgClass(roomAvailable)">
                                                            <td width="70">
                                                                <div class="form-check">
                                                                    <input class="form-check-input ml-1"
                                                                           type="radio" name="roomAvailableRdButton"
                                                                           :id="'roomAvailable'+roomAvailable.id"
                                                                           v-on:click="setRoomInAvailable(roomAvailable)"
                                                                           v-show="!roomAvailable.hasOverStayed"
                                                                           :disabled="isInAvailable"
                                                                           :value="roomAvailable">
                                                                </div>
                                                            </td>
                                                            <td class="font-weight-bold" width="140">{{roomAvailable.name}}</td>
                                                            <td class="font-weight-bold" width="122">{{roomAvailable.code}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="col-md-7 text-left border-left">
                                            <h5 class="font-weight-bold">Rooms Occupied</h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th scope="col" width="80">
                                                                <button class="btn btn-sm ml-1"
                                                                        v-bind:class="{ 'tnkc-success': isInOccupied,'tnkc-secondary' : !isInOccupied}"
                                                                        v-on:click="setSelectOccupied">
                                                                    {{isInOccupied ? 'Select' : 'Undo'}}
                                                                </button>
                                                            </th>
                                                            <th scope="col">Rooms</th>
                                                            <th scope="col" width="100">Beds</th>
                                                            <th scope="col" width="180">Availavility</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style="height: 180px;">
                                                        <tr v-for="roomOccupied in roomsOccupied" :key="roomOccupied.id"  v-bind:class="roomsOccupiedBgClass(roomOccupied)">
                                                            <td width="80">
                                                                <div class="form-check">
                                                                    <input class="form-check-input ml-1"
                                                                           type="radio" name="roomOccupiedRdButton"
                                                                           :id="'roomAvailable'+roomOccupied.id"
                                                                           v-on:click="setRoomInOccupied(roomOccupied)"
                                                                           v-show="!roomOccupied.hasOverStayed"
                                                                           :disabled="isInOccupied"
                                                                           :value="roomOccupied">
                                                                </div>
                                                            </td>
                                                            <td class="font-weight-bold">{{roomOccupied.name}}</td>
                                                            <td class="font-weight-bold" width="100">{{roomOccupied.code}}</td>
                                                            <td class="font-weight-bold small" width="165" v-show="roomOccupied.available_date">{{roomOccupied.available_date | moment("DD MMM YYYY - HH:mm")}}</td>
                                                            <td class="font-weight-bold small"  width="165" v-show="!roomOccupied.available_date">Check-Out/Available</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-sm tnkc-primary" v-on:click="bookedTransfer">Transfer Booked</button>
                    <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal" v-on:click="setThisNull">
                        <font-awesome-icon icon="times"/>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {appMixins} from '../../../mixins/app.mixins';
  import {mapGetters,mapActions} from 'vuex';

  export default {
    name: 'transfferModal',
    mixins:[appMixins],

    props:{
      actionType:Number,
      search: {type: Function},
    },

    data(){
      return {
        tab: 1,
        hotel_id: 1, //default 1 tnkc
        floor_id: null,
        booked_in: '',
        booked_out: '',

        isInAvailable: true,
        isInOccupied: true,

        roomAvail: '',
        roomOccupied: '',

      };
    },

    methods: {

      ...mapActions([
        'setNullNewRemark',
        'setBookedNull',
        'setNullFloors',
        'getFloorsByHotel',
        'bedsPerRoom',
        'setNullRoomAvailable',
        'setNullRoomOccupied',
        'createBooking',
        'setNewBookingNull',
        'transferBooking'
      ]),

      setThisTransfer(){
        this.transfer();
      },

      setBookedIn() {
        this.newBooking.booked_check_in = this.booked_in;
        this.getRooms();
      },

      setBookedOut() {
        this.newBooking.booked_check_out = this.booked_out;
        this.getRooms();
      },

      isActive(val, tabContent = false) {
        if (val == this.tab && !tabContent) {
          this.hotel_id = val;
          return 'active';
        }

        if (val == this.tab && tabContent) {
          return 'show active';
        }
      },

      showTab(val) {
        this.tab = val;
        this.hotel_id = val;
        this.floor_id = null;
        this.getFloors();
        this.setNullRoomAvailable();
        this.setNullRoomOccupied();
        this.clearAvailableRadioBr();
        this.clearOccupiedRadioBr();
        this.availableRooms();
      },

      getFloors() {
        this.getFloorsByHotel({hotel_id: this.hotel_id});
      },

      setThisNull() {
        this.setNullNewRemark();
        // this.setNullFloors();
        this.setNullRoomAvailable();
        this.setNullRoomOccupied();
        this.setBookedNull();
        this.setNewBookingNull();
        this.booked_in = '';
        this.booked_out = '';
        this.floor_id = null;
        this.isInAvailable = true;
        this.isInOccupied = false;
      },

      getRooms() {
        let startDate = Date.parse(this.booked_in);
        let endDate = Date.parse(this.booked_out);
        if (startDate > endDate) {
          this.warningAlert('The check-out date must come after the check-in date');
        }
        this.availableRooms();
      },

      availableRooms() {
        const params = {
          dateFrom: this.booked_in ? this.booked_in : this.booked.booked_check_out,
          dateTo: null,
          hotel_id: this.hotel_id,
          floor_id: this.floor_id,
        };
        this.bedsPerRoom(params);
      },

      setDefaultCheckIn() {
        this.booked_in = this.defaultCheckIn;
        this.newBooking.booked_check_in = this.booked_in;
        this.getRooms();
      },

      setDefaultCheckOut() {
        this.booked_out = this.defaultCheckOut;
        this.newBooking.booked_check_out = this.booked_out;
        this.getRooms();
      },

      setRoomInAvailable(objectData) {
        this.newBooking.reservation_id = this.reservation_id;
        this.newBooking.hotel_id = this.hotel_id ? this.hotel_id : objectData.hotel_id;
        this.newBooking.floor_id = this.floor_id ? this.floor_id : objectData.floor_id;
        this.newBooking.room_id = objectData.id;
        this.newBooking.bed_id = objectData.bed_id;
        // this.booked_in = null;
      },

      setRoomInOccupied(objectData) {
        this.booked_in = this.formatDate(objectData.available_date);
        this.newBooking.reservation_id = this.reservation_id;
        this.newBooking.hotel_id = this.hotel_id;
        this.newBooking.floor_id = this.floor_id ? this.floor_id : objectData.floor_id;
        this.newBooking.room_id = objectData.id;
        this.newBooking.bed_id = objectData.bed_id;
        this.newBooking.booked_check_in = this.booked_in;

        if (this.booked_in != null || this.booked_in != '') {
          let html = `<span class="font-weight-bold">Select <b class="text-danger">*</b><u>Booked Check-Out</u>.</span>`;
          this.successAlert('', 'Set Room & Check-in', html);
        }
      },

      setSelectAvailable() {
        this.newBooking.booked_check_in = null;
        this.booked_in = null;
        this.isInAvailable = !this.isInAvailable;
        this.isInOccupied = true;
        this.clearAvailableRadioBr();
        this.clearOccupiedRadioBr();
      },

      setSelectOccupied() {
        this.isInOccupied = !this.isInOccupied;
        this.isInAvailable = true;
        this.clearAvailableRadioBr();
        this.clearOccupiedRadioBr();
      },

      clearAvailableRadioBr() {
        let ele = document.getElementsByName('roomAvailableRdButton');
        for (let i = 0; i < ele.length; i++) {
          ele[i].checked = false;
        }
        // this.newBooking.room_id = '';
      },

      clearOccupiedRadioBr() {
        let ele = document.getElementsByName('roomOccupiedRdButton');
        for (let i = 0; i < ele.length; i++) {
          ele[i].checked = false;
        }
        // this.newBooking.room_id = '';
      },

      formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      async bookedTransfer(){
        this.newBooking.remarks = this.newRemarks;
        this.newBooking.booked = this.booked;  //add booked on the fly properties
        if(await this.questionAlert('Are you sure you want to, transffer this crew.')){
          console.log(this.newBooking);
          this.transferBooking(this.newBooking).then((res)=>{
            if(res == true){
              this.search();
              this.setNullNewRemark();
              this.setNullRoomAvailable();
              this.setNullRoomOccupied();
              this.isInAvailable = true;
              this.isInOccupied = false;
            }
          });
        }
      },


      roomsOccupiedBgClass(obj = null){
        if(!obj.available_date && !obj.hasOverStayed){
          return 'tnkc-success';
        }

        if(obj.hasOverStayed){
          return 'isOverstayBg';
        }
        return ''; // no style
      },

      roomsAvailableBgClass(obj = null){
        if(obj.hasOverStayed){
          return 'isOverstayBg';
        }
        return ''; // no style
      }


    },

    computed: {
      ...mapGetters([
        'newRemarks',
        'newBooking',
        'floors',
        'reservDtls',
        'roomsAvailable',
        'roomsOccupied',
        'newBooking',
         'booked'
      ]),


      bookedIn : {
        get : function(){
          let val = null;
          if(this.booked.booked_check_in){
            this.newBooking.booked_check_in = this.booked.booked_check_in;
            val = this.formatDate(this.booked.booked_check_in);
          }
          return val;
        },

        set : function(value){
          this.newBooking.booked_check_in = value;
        }
      }
    },

    created() {
      //todo
      this.getFloors();
    },

    mounted() {
      //todo
    },
  }
</script>

<style scoped>
    input[type=checkbox] {
        transform: scale(1.6);
    }


    input[type=radio] {
        transform: scale(1.6);
    }


    a.active:hover,
    a.active:focus,
    button.tnkc-primary:hover,
    button.tnkc-primary:focus {
        background-color: #34abff !important;
        color: #4a4f54;
    }

    table {
        display: flex;
        flex-flow: column;
        width: 100%;

    }

    thead {
        flex: 0 0 auto;
    }

    tbody {
        flex: 1 1 auto;
        display: block;
        overflow-y: auto;
        overflow-x: hidden;
    }

    tr {
        width: 100%;
        display: table;
        table-layout: fixed;
    }

    ::-webkit-scrollbar {
      width: 15px !important;
    }

</style>
